import axios from "axios";
import {
  COMPANY_ALL_ACTIONS_TYPE,
  COMPANY_MODAL_ACTION_TYPE,
  CONSULTATION_ALL_ACTIONS_TYPE,
  CONSULTATION_COMPANY_MODAL_ACTION_TYPE,
  CONSULTATION_MODAL_ACTION_TYPE,
  DOWNLOAD_EXCEL_ACTION_TYPE,
} from "../actions-type";
import { toast } from "react-toastify";
import { logoutAction } from "./auth";
import { apiRoot } from "../../apiRoot";

const refreshApi = axios.create({
  baseURL: `${apiRoot}/user/auth/refresh_token`,
  withCredentials: true,
});

const API = axios.create({
  baseURL: `${apiRoot}/company`,
  withCredentials: true,
});
const REGISTERAPI = axios.create({
  baseURL: `${apiRoot}/user/auth`,
  withCredentials: true,
});

API.interceptors.request.use((req) => {
  if (localStorage.getItem("auth")) {
    req.headers.Authorization = `Bearer ${
      JSON.parse(localStorage.getItem("auth")).AccessToken
    }`;
  }

  return req;
});

REGISTERAPI.interceptors.request.use((req) => {
  if (localStorage.getItem("auth")) {
    req.headers.Authorization = `Bearer ${
      JSON.parse(localStorage.getItem("auth")).AccessToken
    }`;
  }

  return req;
});

const pageLoading = (loadingValue) => ({
  type: COMPANY_ALL_ACTIONS_TYPE.COMPANY_LOADING,
  payload: loadingValue,
});
export const setLoadingConsultationAction = (loadingValue) => ({
  type: CONSULTATION_ALL_ACTIONS_TYPE.CONSULTATION_LOADING_ALL,
  payload: loadingValue,
});
const modalLoading = (loadingValue) => ({
  type: COMPANY_MODAL_ACTION_TYPE.COMPANY_MODAL_LOADING,
  payload: loadingValue,
});

const consultationCompanyModalLoading = (loadingValue) => ({
  type: CONSULTATION_COMPANY_MODAL_ACTION_TYPE.CONSULTATION_COMPANY_MODAL_LOADING,
  payload: loadingValue,
});

const downloadExcelLoading = (value) => ({
  type: DOWNLOAD_EXCEL_ACTION_TYPE.LOADING,
  payload: value,
});
const toastSuccess = (message) => {
  toast.success(message, {
    position: "top-right",
    autoClose: 2000,
    hideProgressBar: false,
    closeOnClick: true,
    pauseOnHover: true,
    draggable: true,
    progress: undefined,
    theme: "colored",
  });
};
const toastError = (message) => {
  toast.error(message, {
    position: "top-right",
    autoClose: 2000,
    toastClassName: "custom-toast",
    hideProgressBar: false,
    closeOnClick: true,
    pauseOnHover: true,
    draggable: true,
    progress: undefined,
    theme: "colored",
  });
};

export const getCompanyPaginationAction =
  (length, searchQuery, contractType) => async (dispatch) => {
    dispatch(pageLoading(true));

    try {
      const { data } = await API.get(
        `/pagination?length=${length}&searchQuery=${searchQuery}&contractType=${contractType}`,
      );

      dispatch({
        type: COMPANY_ALL_ACTIONS_TYPE.GET_COMPANY_PAGINATION,
        payload: data,
      });
    } catch (error) {
      if (error?.response?.status === 401 || error?.response?.status === 403) {
        return dispatch(logoutAction());
      }
    } finally {
      dispatch(pageLoading(false));
    }
  };

export const getConsultationCompanyPaginationAction =
  (
    length,
    searchQuery,
    phone,
    contractType = "",
    status = "",
    startDate,
    endDate,
    courseId = "",
    whereComing = "",
    whereForDate = "",
    workerId = "",
  ) =>
  async (dispatch) => {
    dispatch(pageLoading(true));

    try {
      const { data } = await API.get(
        `/consultation/pagination?length=${length}&searchQuery=${
          searchQuery || ""
        }&phone=${phone}&status=${status || ""}&contractType=${contractType || ""}&startDate=${
          startDate || ""
        }&endDate=${endDate || ""}&courseId=${courseId || ""}&whereComing=${
          whereComing || ""
        }&whichForDate=${whereForDate}&workerId=${workerId || ""}`,
      );

      dispatch({
        type: COMPANY_ALL_ACTIONS_TYPE.GET_COMPANY_PAGINATION,
        payload: data,
      });
    } catch (error) {
      if (error?.response?.status === 401 || error?.response?.status === 403) {
        return dispatch(logoutAction());
      }
    } finally {
      dispatch(pageLoading(false));
    }
  };

export const getCompanyDropdownAction = () => async (dispatch) => {
  try {
    const { data } = await API.get(`/dropdown`);

    dispatch({
      type: COMPANY_ALL_ACTIONS_TYPE.GET_COMPANY_DROPDOWN,
      payload: data,
    });
  } catch (error) {
    if (error?.response?.status === 401 || error?.response?.status === 403) {
      return dispatch(logoutAction());
    }
  }
};

export const createCompanyAction = (newData) => async (dispatch) => {
  dispatch(modalLoading(true));
  try {
    const { data } = await API.post("/", newData);
    dispatch({
      type: COMPANY_ALL_ACTIONS_TYPE.CREATE_COMPANY,
      payload: data,
    });
    dispatch({
      type: COMPANY_MODAL_ACTION_TYPE.COMPANY_OPEN_MODAL,
      payload: false,
    });
    toastSuccess("Yeni şirkət yaradıldı");
  } catch (error) {
    if (error?.response?.status === 401 || error?.response?.status === 403) {
      return dispatch(logoutAction());
    }

    if (error?.response?.data?.key === "invalid-power") {
      toastError("Məlumatı yeniləmək səlahiyyətiniz yoxdur");
    }
  } finally {
    dispatch(modalLoading(false));
  }
};

export const createConsultationCompanyAction =
  (newData) => async (dispatch) => {
    dispatch(consultationCompanyModalLoading(true));
    try {
      const { data } = await API.post("/consultation", newData);
      dispatch({
        type: COMPANY_ALL_ACTIONS_TYPE.CREATE_COMPANY,
        payload: data,
      });
      dispatch({
        type: CONSULTATION_COMPANY_MODAL_ACTION_TYPE.CONSULTATION_COMPANY_OPEN_MODAL,
        payload: false,
      });
      toastSuccess("Lead yaradıldı");
    } catch (error) {
      if (error?.response?.status === 401 || error?.response?.status === 403) {
        return dispatch(logoutAction());
      }

      if (error?.response?.data?.key === "invalid-power") {
        toastError("Məlumatı yeniləmək səlahiyyətiniz yoxdur");
      }
    } finally {
      dispatch(consultationCompanyModalLoading(false));
    }
  };

export const updateCompanyAction = (_id, newData) => async (dispatch) => {
  dispatch(modalLoading(true));
  try {
    const { data } = await API.patch(`/${_id}`, newData);
    dispatch({
      type: COMPANY_ALL_ACTIONS_TYPE.UPDATE_COMPANY,
      payload: data,
    });
    dispatch({
      type: COMPANY_MODAL_ACTION_TYPE.COMPANY_OPEN_MODAL,
      payload: false,
    });
    toastSuccess("Şirkət yeniləndi");
  } catch (error) {
    if (error?.response?.status === 401 || error?.response?.status === 403) {
      return dispatch(logoutAction());
    }

    if (error?.response?.data?.key === "invalid-power") {
      toastError("Məlumatı yeniləmək səlahiyyətiniz yoxdur");
    }
  } finally {
    dispatch(modalLoading(false));
  }
};

export const updateConsultationCompanyAction =
  (_id, newData) => async (dispatch) => {
    dispatch(consultationCompanyModalLoading(true));
    try {
      const { data } = await API.patch(`/consultation/${_id}`, newData);
      dispatch({
        type: COMPANY_ALL_ACTIONS_TYPE.UPDATE_COMPANY,
        payload: data,
      });
      dispatch({
        type: CONSULTATION_COMPANY_MODAL_ACTION_TYPE.CONSULTATION_COMPANY_OPEN_MODAL,
        payload: false,
      });
      toastSuccess("Lead yeniləndi");
    } catch (error) {
      if (error?.response?.status === 401 || error?.response?.status === 403) {
        return dispatch(logoutAction());
      }

      if (error?.response?.data?.key === "invalid-power") {
        toastError("Məlumatı yeniləmək səlahiyyətiniz yoxdur");
      }
    } finally {
      dispatch(consultationCompanyModalLoading(false));
    }
  };

export const uploadCompanyContractAction =
  (_id, formData) => async (dispatch) => {
    dispatch(modalLoading(true));

    try {
      const { data } = await API.patch(`/upload-contract/${_id}`, formData);

      dispatch({
        type: COMPANY_ALL_ACTIONS_TYPE.UPDATE_COMPANY,
        payload: data,
      });

      toastSuccess("Fayl yükləndi");
    } catch (error) {
      if (error?.response?.status === 401 || error?.response?.status === 403) {
        return dispatch(logoutAction());
      }

      if (error?.response?.data?.key === "invalid-power") {
        toastError("Məlumatı yeniləmək səlahiyyətiniz yoxdur");
      }
    } finally {
      dispatch(modalLoading(false));
    }
  };

export const deleteConmpanyContractAction = (_id) => async (dispatch) => {
  dispatch(modalLoading(true));

  try {
    const { data } = await API.patch(`/delete-contract/${_id}`);

    dispatch({
      type: COMPANY_ALL_ACTIONS_TYPE.UPDATE_COMPANY,
      payload: data,
    });

    toastSuccess("Fayl silindi");
  } catch (error) {
    if (error?.response?.status === 401 || error?.response?.status === 403) {
      return dispatch(logoutAction());
    }

    if (error?.response?.data?.key === "invalid-power") {
      toastError("Məlumatı yeniləmək səlahiyyətiniz yoxdur");
    }
  } finally {
    dispatch(modalLoading(false));
  }
};

export const downloadCompanyContractAction = (data) => async (dispatch) => {
  console.log(data);
  try {
    if (!data.signedContractPath) {
      toastError("Fayl mövcud deyil");
      return;
    }

    const response = await API.get(`/download-contract/${data._id}`, {
      responseType: "blob",
    });

    const blob = new Blob([response.data], {
      type: "application/pdf",
    });

    const url = window.URL.createObjectURL(blob);
    const a = document.createElement("a");
    a.href = url;
    a.download = data.name || "";
    a.click();
    window.URL.revokeObjectURL(url);
  } catch (error) {
    toastError("Fayl endirilmədi");
  }
};

export const uploadCompanyAdditionalContractAction =
  (_id, formData) => async (dispatch) => {
    dispatch(modalLoading(true));

    try {
      const { data } = await API.patch(
        `/upload-additional-contract/${_id}`,
        formData,
      );

      dispatch({
        type: COMPANY_ALL_ACTIONS_TYPE.UPDATE_COMPANY,
        payload: data,
      });

      toastSuccess("Fayl yükləndi");
    } catch (error) {
      if (error?.response?.status === 401 || error?.response?.status === 403) {
        return dispatch(logoutAction());
      }

      if (error?.response?.data?.key === "invalid-power") {
        toastError("Məlumatı yeniləmək səlahiyyətiniz yoxdur");
      }
    } finally {
      dispatch(modalLoading(false));
    }
  };

export const deleteConmpanyAdditionalContractAction =
  (_id, payload) => async (dispatch) => {
    dispatch(modalLoading(true));

    try {
      const { data } = await API.patch(
        `/delete-additional-contract/${_id}`,
        payload,
      );

      dispatch({
        type: COMPANY_ALL_ACTIONS_TYPE.UPDATE_COMPANY,
        payload: data,
      });

      toastSuccess("Fayl silindi");
    } catch (error) {
      if (error?.response?.status === 401 || error?.response?.status === 403) {
        return dispatch(logoutAction());
      }

      if (error?.response?.data?.key === "invalid-power") {
        toastError("Məlumatı yeniləmək səlahiyyətiniz yoxdur");
      }
    } finally {
      dispatch(modalLoading(false));
    }
  };

export const downloadCompanyAdditionalContractAction =
  (data, payload) => async (dispatch) => {
    console.log(data);
    try {
      if (!payload.fileName) {
        toastError("Fayl mövcud deyil");
        return;
      }

      const response = await API.post(
        `/download-additional-contract/${data._id}`,
        payload,
        {
          responseType: "blob",
        },
      );

      const blob = new Blob([response.data], {
        type: "application/vnd.openxmlformats-officedocument.wordprocessingml.document",
      });

      const url = window.URL.createObjectURL(blob);
      const a = document.createElement("a");
      a.href = url;
      a.download = data.name || "";
      a.click();
      window.URL.revokeObjectURL(url);
    } catch (error) {
      toastError("Fayl endirilmədi");
    }
  };

export const confirmConsultationCompanyAction = (_id) => async (dispatch) => {
  dispatch(consultationCompanyModalLoading(true));

  try {
    const { data } = await API.patch(`/confirm/${_id}`);

    dispatch({
      type: COMPANY_ALL_ACTIONS_TYPE.UPDATE_COMPANY,
      payload: data,
    });

    toastSuccess("konsultasiya təstiqləndi");
  } catch (error) {
    if (error?.response?.data?.key === "data-not-completed") {
      toastError("Təstiqləmə üçün məlumatlar tamamlanmayıb");
    }

    if (error?.response?.data?.key === "invalid-power") {
      toastError("Məlumatı təstiqləmə səlahiyyətiniz yoxdur");
    }

    if (error?.response?.status === 401 || error?.response?.status === 403) {
      return dispatch(logoutAction());
    }
  } finally {
    dispatch(consultationCompanyModalLoading(false));
  }
};
